import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useFeaturedPhotosPromoX3 = () => {
  return useShallowEqualSelector(({ systemReducer: { services } }) => ({
    isFeaturedPhotosPromoX3Active: services?.featuredPhotosPromoX3?.isActive,
    /** Секунды */
    promoEndDate: services?.featuredPhotosPromoX3?.until,
  }))
}
